import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IMG_FERN, IMG_COAST } from "@/lib/images";
import Prose from "@/components/Prose";
import BuiltWithEmergent from "@/components/BuiltWithEmergent";

export default function PageView({ slug }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    setP(null);
    api.get(`/public/pages/${slug}`).then(({ data }) => setP(data)).catch(() => setP({ title: "Page unavailable", body: "" }));
  }, [slug]);

  return (
    <>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20 grid lg:grid-cols-12 gap-12" data-testid={`page-${slug}`}>
      <div className="lg:col-span-7">
        <p className="eyebrow rise">{slug === "legal" ? "Policy" : "About"}</p>
        <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f]" data-testid="page-title">{p?.title || "…"}</h1>
        <div className="mt-12 rise d2"><Prose text={p?.body || ""} /></div>
      </div>
      <div className="lg:col-span-4 lg:col-start-9 hidden lg:block">
        <div className="sticky top-28 aspect-[3/4] overflow-hidden">
          <img src={slug === "legal" ? IMG_FERN : IMG_COAST} alt="New Zealand landscape" className="w-full h-full object-cover" />
        </div>
      </div>
    </div>
    {slug === "about" && <BuiltWithEmergent />}
    </>
  );
}
